import { render, staticRenderFns } from "./CommonTab.vue?vue&type=template&id=2b2bcadc&scoped=true"
import script from "./CommonTab.vue?vue&type=script&lang=js"
export * from "./CommonTab.vue?vue&type=script&lang=js"
import style0 from "./CommonTab.vue?vue&type=style&index=0&id=2b2bcadc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2bcadc",
  null
  
)

export default component.exports